import { storyActions } from '../actionTypes/index';

const initialState = {
  currentStoryId: '',
  storyExpanded: false,
  storiesArr: [],
  brandName: '',
  brandLogo: '',
  storyType: '',
  brandId: ''
};

const storyReducer = (state = initialState, action) => {
  switch (action.type) {
    case storyActions.SET_STORY_ID:
      return {
        ...state,
        currentStoryId: action.payload.storyId,
        storyExpanded: true,
        storiesArr: action.payload.storiesArr,
        brandName: action.payload.brandName,
        brandLogo: action.payload.brandLogo,
        storyType: action.payload.storyType,
        brandId: action.payload.brandId
      };

    case storyActions.CLOSE_STORY:
      return {
        ...state,
        currentStoryId: '',
        storyExpanded: false,
        storiesArr: [],
        brandName: '',
        brandLogo: '',
        storyType: '',
        brandId: ''
      };

    case storyActions.UPDATE_STORIES:
      return {
        ...state,
        storiesArr: [
          ...state.storiesArr,
          ...(action?.payload?.feedStoriesRes?.layout?.components?.[0]?.subcomponent || [])
        ]
      };

    // case storyActions.SUB_STORY_SEEN:
    //   return {
    //     ...state,
    //     storiesArr: action.payload.updatedStoriesArr
    //   };

    default:
      return state;
  }
};

export default storyReducer;
